function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import cn from 'classnames';
import chunk from 'lodash/chunk';
import compact from 'lodash/compact';
import find from 'lodash/find';
import upperFirst from 'lodash/upperFirst';
import map from 'lodash/map';
import XIcon from 'svg/x.svg';
import Globe from 'svg/globe.svg';
import CheckCircle from 'svg/check-circle.svg';
import intlShape from 'shapes/intlShape';
import Button from 'components/Form/Button';
import messages from '../../messages';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
var _React_PureComponent;
class LanguageSelector extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (typeof Intl.DisplayNames === 'function') {
            this.displayNames = new Intl.DisplayNames([
                this.props.locale
            ], {
                type: 'language'
            });
        }
    }
    componentDidUpdate(props) {
        if (props.locale !== this.props.locale && typeof Intl.DisplayNames === 'function') {
            this.displayNames = new Intl.DisplayNames([
                this.props.locale
            ], {
                type: 'language'
            });
        }
    }
    onToggleDropdown(evt) {
        if (this.props.openDropdownId === constants.LANGUAGE_SELECTOR_DROPDOWN || this.props.activeVisit) {
            this.props.onCloseDropdown();
            return;
        }
        evt.stopPropagation();
        this.props.onOpenDropdown();
    }
    getLanguageLocalName(code) {
        if (!this.displayNames) return null;
        return upperFirst(this.displayNames.of(code));
    }
    renderLocale(locale) {
        const { languages, isMobileDisplayMode } = this.props;
        const langCode = constants.APP_LOCALE_LANGUAGES_MAP[locale] || locale;
        const language = find(languages, (lang)=>lang.code === langCode);
        if (!language) {
            return null;
        }
        const { englishName } = language;
        let { nativeName } = language;
        const isActive = locale === this.props.locale;
        if (isMobileDisplayMode && locale === 'en') {
            nativeName = englishName;
        }
        const lName = this.getLanguageLocalName(langCode) || englishName;
        return /*#__PURE__*/ _jsx("li", {
            className: cn('dropdownMenu__action', {
                'dropdownMenu__action--active': locale === this.props.locale
            }),
            children: /*#__PURE__*/ _jsx(Button, {
                type: "button",
                styleModifier: "transparent",
                onClick: ()=>this.props.onSetLocale(locale),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "languageSelector__locale",
                    children: [
                        isMobileDisplayMode && isActive && /*#__PURE__*/ _jsx(CheckCircle, {
                            className: "languageSelector__locale__checkIcon"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "languageSelector__locale__names",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "languageSelector__locale__nativeName",
                                    children: upperFirst(nativeName)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "languageSelector__locale_englishName",
                                    children: isMobileDisplayMode && upperFirst(lName)
                                })
                            ]
                        })
                    ]
                })
            })
        }, locale);
    }
    renderLocaleChunk(localeChunk, idx) {
        return /*#__PURE__*/ _jsx("ul", {
            className: "languageSelector__localesColumn",
            children: map(localeChunk, (localeElement)=>localeElement)
        }, idx);
    }
    renderHeaders() {
        if (!this.props.isMobileDisplayMode) return null;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    "aria-hidden": "true",
                    className: "languageSelector__closeIconWrapper",
                    onClick: (evt)=>this.onToggleDropdown(evt),
                    children: /*#__PURE__*/ _jsx(XIcon, {
                        className: "languageSelector__closeIcon"
                    })
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "text--h2 mb-2 languageSelector__headingText",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.language))
                })
            ]
        });
    }
    renderLocales() {
        if (this.props.openDropdownId !== constants.LANGUAGE_SELECTOR_DROPDOWN) {
            return null;
        }
        const locales = this.props.isMobileDisplayMode ? constants.MOBILE_APP_LOCALES : constants.APP_LOCALES;
        const localesChunks = chunk(compact(map(locales, (locale)=>this.renderLocale(locale))), 9);
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                height: 0
            },
            animate: {
                height: 'inherit'
            },
            exit: {
                height: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "languageSelector__locales dropdownMenu__actions",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "languageSelector__locales__inner",
                children: [
                    this.renderHeaders(),
                    map(localesChunks, (localeChunk, idx)=>this.renderLocaleChunk(localeChunk, idx))
                ]
            })
        });
    }
    render() {
        const { languages, langCode, isMobileDisplayMode } = this.props;
        const language = find(languages, (lang)=>lang.code === langCode);
        if (!language) {
            return null;
        }
        const tooltipMsg = this.props.activeVisit ? messages.infos.menuDisabledIfActiveVisit : messages.labels.language;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('languageSelector', this.props.className),
            children: [
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "languageSelector__btn",
                    onClick: (evt)=>this.onToggleDropdown(evt),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "languageSelector__inner",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx(Globe, {
                                    className: "languageSelector__icon",
                                    "data-for": this.props.withTooltip ? 'sidebar' : '',
                                    "data-place": this.props.tooltipPlace,
                                    "data-tip": this.props.intl.formatMessage(tooltipMsg),
                                    "data-offset": this.props.tooltipOffset
                                })
                            }),
                            !this.props.hideLabel && /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "languageSelector__current",
                                    children: isMobileDisplayMode && langCode === 'en' ? language.englishName : language.nativeName
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(AnimatePresence, {
                    children: this.renderLocales()
                })
            ]
        });
    }
}
_define_property(LanguageSelector, "propTypes", {
    // Explicit props
    hideLabel: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    tooltipOffset: PropTypes.string,
    tooltipPlace: PropTypes.string,
    activeVisit: PropTypes.object,
    // Implicit props
    languages: PropTypes.arrayOf(shapes.language),
    locale: PropTypes.string,
    langCode: PropTypes.string,
    openDropdownId: PropTypes.string,
    intl: intlShape,
    isMobileDisplayMode: PropTypes.bool,
    // Implicit actions
    onSetLocale: PropTypes.func,
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func,
    withTooltip: PropTypes.bool
});
const mapStateToProps = (state)=>({
        languages: selectors.languages(state),
        locale: selectors.locale(state),
        langCode: selectors.langCode(state),
        direction: selectors.direction(state),
        openDropdownId: selectors.dropdown(state),
        isMobileDisplayMode: selectors.isMobileDisplayMode(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSetLocale: (locale)=>Promise.all([
                dispatch(actions.setLocale(locale)),
                dispatch(actions.fetchLocalizationResources()),
                dispatch(actions.closeDropdown())
            ]),
        onOpenDropdown: ()=>dispatch(actions.openDropdown(constants.LANGUAGE_SELECTOR_DROPDOWN)),
        onCloseDropdown: ()=>dispatch(actions.closeDropdown())
    });
const ConnectedLanguageSelector = connect(mapStateToProps, mapDispatchToProps)(injectIntl(LanguageSelector));
export default ConnectedLanguageSelector;
